import React, { useContext, useState } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import { useNavigate } from "react-router-dom";

import ApiEndpoints from "../network/ApiEndPoints";
import { CustomStyles } from "../component/CustomStyle";
import { currencySetter } from "../utils/Currencyutil";
import AuthContext from "../store/AuthContext";
import ApiPaginateSearch from "../component/ApiPaginateSearch";
import FilterCard from "../modals/FilterCard";
let refresh;

let refreshFuncRef;


function refreshFunc(setQueryParams) {
  setQueryParams("");
  if (refresh) refresh();
}
const W_Balance = () => {
 
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  const authctx = useContext(AuthContext);
  const user = authctx.user;

  const columns = [
    {
      name: "ID",
      selector: (row) => <div className="blue-highlight-txt">{row.id}</div>,
      width: "70px",
    },
    {
      name: "Username",
      selector: (row) => row.username || "NA",
    },
    {
      name: "Establishment",
      selector: (row) => (
        <Tooltip title={row.establishment || "NA"}>
          <div style={{ textAlign: "left" }}>{row.establishment || "NA"}</div>
        </Tooltip>
      ),
      width: "250px",
      wrap: true,
    },
    {
      name: "W1",
      selector: (row) => currencySetter(row.w1),
    },
    {
      name: "W2",
      selector: (row) => currencySetter(row.w2),
    },
    {
      name: "W3",
      selector: (row) => currencySetter(row.w3),
    },
    {
      name: "Hold",
      selector: (row) => currencySetter(row.hold),
    },
    {
      name: "Hold 2",
      selector: (row) => currencySetter(row.hold2),
    },
    {
      name: "Role",
      selector: (row) => row.role || "NA",
    },
    {
      name: "Actions",
      selector: (row) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          {/* Add action buttons here if needed */}
        </Box>
      ),
    },
  ];

  return (
    <Box>
   <Box sx={{ display: "flex", justifyContent: "end" }}>
      
      </Box>
    <div>
      {/* Wallet Balance Table */}
      <ApiPaginateSearch
        apiEnd={ApiEndpoints.GET_WALLET_BAL}
        columns={columns}
        setQuery={setQuery}
        queryParam={query}
                returnRefetch={(ref) => {
            refresh = ref;
          }}
        tableStyle={CustomStyles}
 
                isFilterAllowed={true}
    
        filterComponent={
          <FilterCard
            setQuery={setQuery}
            ifestFilter
            ifUsernameFilter
            ifuseridFilter
            query={query}
          actionButtons={
                            <Box sx={{ display: "flex",}}>
            
                              <Tooltip title="refresh">
                                <IconButton
                                  className=""
                                  aria-label="refresh"
                                  color="success"
                                  onClick={() => {
                                    refreshFunc(setQuery);
                                  }}
                                >
                                  <CachedIcon className="refresh-purple" />
                                </IconButton>
                              </Tooltip>
                              </Box>
          }
          />
        }
      />
    </div>
        </Box>

  );
};

export default W_Balance;
